export default {
    orders: [],
    totalOrders: 0,
    paramsSearch: {
        statuses: [],
        deps: [],
        price_min: '',
        price_max: '',
    },
    statuses: [],
    statusesForChange: [],
    previewOrder: {},
    changesOrder: [],
    printedOrders: [],
    unprintedInvoices: [],
    printedInvoicesCount: 0,
    couriers: [],
    couriersByRestaurant: [],
    menu: [],
    menuTotal: 0,
    notifications: [],
    restaurant: null,
    divisions: [],
    selectedNotify: null,
    isMultiPrintInProgress: false,
    multiPrintJob: null,
}
